import React from 'react';
import { pluralize } from '../../../../Shared';

export default class UnitTemplateSecondRow extends React.Component {
  authorName = () => {
    const { data, } = this.props
    let name;
    if (data.author) {
      name = data.author.name;
    } else {
      name = null;
    }
    return name;
  };

  numberOfActivities = () => {
    const { data, } = this.props
    return data.activities ? data.activities.length : 0;
  };

  sayActivitiesCount = () => {
    const { modules, } = this.props
    return modules.string.sayNumberOfThings(this.numberOfActivities(), 'Activity', 'Activities')
  };

  sayTime = () => {
    const { data, } = this.props
    return [data.time, 'mins'].join(' ');
  };

  renderGradeLevelRange = () => {
    const { data, } = this.props
    const gradeBandNames = data.grade_band_names || []

    if (!gradeBandNames.length) { return <span />}

    const label = `Grade ${pluralize(gradeBandNames.length, 'Range', 'Ranges')}`

    return (
      <div className="grade-level-range">
        <i className='fas fa-book-open' />
        <span>{label}: {gradeBandNames.join(', ')}</span>
      </div>
    )
  }

  render() {
    const { showPreviewAndAssign, } = this.props
    return (
      <div className='white-row'>
        <div className='info-row'>
          <div>
            <div className='activities-count'>
              <i className='fas fa-th-list' />
              {this.sayActivitiesCount()}
            </div>
          </div>
          {this.renderGradeLevelRange()}
          <div className='time'>
            <i className='far fa-clock' />
            <div className='time-number'>
              {this.sayTime()}
            </div>
          </div>
        </div>
        {showPreviewAndAssign && <span aria-hidden="true" className="quill-button extra-small outlined teal focus-on-light preview-and-assign-button">Preview &amp; Assign</span>}
      </div>
    );
  }
}
